export const ROSEMOUNT_CATEGORIES = [
  "Mortgage",
  "Protection",
  "Pension",
  "Investment",
  "GI",
  "Lifetime",
  "Long Term Care",
  "Bridging and Commercial",
];

export const COMMISSION_CLASSIFICATIONS = {
  "Ad-hoc Fee": "New Business",
  "Initial Commission": "New Business",
  "Initial Fee": "New Business",
  "Single Premium": "New Business",
  "Fund Based Commission": "Ongoing",
  "Ongoing Fee": "Ongoing",
  Renewal: "Ongoing",
  "Renewal Commission": "Ongoing",
};

const normalise = (value) => String(value || "").trim().toLocaleLowerCase("en-GB");
const amount = (row) => Number(row?.PaymentAmount) || 0;

const commissionClassificationByKey = Object.fromEntries(
  Object.entries(COMMISSION_CLASSIFICATIONS).map(([type, classification]) => [
    normalise(type),
    classification,
  ]),
);

export const buildPlanCategoryLookup = (mappings = []) =>
  Object.fromEntries(
    mappings
      .map((mapping) => [
        normalise(mapping.businessType || mapping.planTypeName),
        String(mapping.planCategory || "").trim(),
      ])
      .filter(([planType, category]) => planType && category),
  );

export const classifyCommissionType = (commissionType) =>
  commissionClassificationByKey[normalise(commissionType)] ||
  "New Business";

export const buildBusinessSummary = (rows = [], categoryByPlanType = {}) => {
  const categoryTotals = Object.fromEntries(
    ROSEMOUNT_CATEGORIES.map((category) => [category, 0]),
  );
  const commissionTotals = Object.fromEntries(
    Object.keys(COMMISSION_CLASSIFICATIONS).map((type) => [type, 0]),
  );
  const commissionLabelsByKey = Object.fromEntries(
    Object.keys(COMMISSION_CLASSIFICATIONS).map((type) => [normalise(type), type]),
  );
  let total = 0;
  let newBusiness = 0;
  let ongoing = 0;
  let unmappedCategory = 0;

  rows.forEach((row) => {
    const paymentAmount = amount(row);
    total += paymentAmount;

    const commissionType = String(row?.CommissionType || "").trim() || "Unknown";
    const commissionKey = normalise(commissionType);
    const commissionLabel = commissionLabelsByKey[commissionKey] || commissionType;
    const classification = classifyCommissionType(commissionType);
    commissionTotals[commissionLabel] = (commissionTotals[commissionLabel] || 0) + paymentAmount;

    if (classification === "New Business") newBusiness += paymentAmount;
    if (classification === "Ongoing") ongoing += paymentAmount;

    const category = categoryByPlanType[normalise(row?.BusinessType)];
    if (category && Object.prototype.hasOwnProperty.call(categoryTotals, category)) {
      categoryTotals[category] += paymentAmount;
    } else {
      unmappedCategory += paymentAmount;
    }
  });

  const commissionTypes = Object.entries(commissionTotals)
    .map(([type, value]) => ({
      type,
      classification: classifyCommissionType(type),
      amount: value,
    }))
    .sort((left, right) => {
      const classificationOrder = {
        "New Business": 0,
        Ongoing: 1,
        "Needs classification": 2,
      };
      return (
        classificationOrder[left.classification] -
          classificationOrder[right.classification] ||
        left.type.localeCompare(right.type, "en-GB", { sensitivity: "base" })
      );
    });

  return {
    total,
    newBusiness,
    ongoing,
    categoryTotals,
    unmappedCategory,
    commissionTypes,
  };
};
